import {
    CREATEROLEMAPPING_SUCCESS,
    CREATEROLEMAPPING_FAILED,
    RESET_CREATEROLEMAPPING,
    LOADING_CREATEROLEMAPPING,
    NETWORK_ERROR_CREATEROLEMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetCreateRoleMapping = () => {
    return { type: RESET_CREATEROLEMAPPING };
};

const createRoleMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CREATEROLEMAPPING });
    await adminServices
        .post("createRoleMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(createRoleMappingsuccess(res.data));
                    break;
                default:
                    dispatch(createRoleMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_CREATEROLEMAPPING, payload: err });
        });
};
function createRoleMappingsuccess(data) {
    return {
        type: CREATEROLEMAPPING_SUCCESS,
        payload: data,
    };
}
function createRoleMappingFailed(data) {
    return {
        type: CREATEROLEMAPPING_FAILED,
        payload: data,
    };
}

export { resetCreateRoleMapping, createRoleMapping };
